<template>
  <div class="text-left">
    <b class="f5">Status Pesanan</b>
    <el-divider></el-divider>
    <div v-for="(item, index) in statusUpdates" :key="index" class="pr4">
      <el-row>
        <el-col>
          <span class="label-text">{{getDate(item.createdAt)}}</span>
          <span class="label-text pull-right">{{getTime(item.createdAt)}}</span>
        </el-col>
        <el-col>
          {{ $_strings.order.getStatusText(item.status) }}
        </el-col>
      </el-row>
      <el-divider></el-divider>
    </div>

    <!-- <GmapMap
      :center="vehicleLocation"
      :zoom="15"
      map-type-id="terrain"
      class="w-100 h5"
      :options="{
        zoomControl: false,
        center: vehicleLocation,
        mapTypeControl: false,
        scaleControl: true,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: true
      }"
    >
      <GmapMarker
        :position="vehicleLocation"
        :clickable="true"
        :icon="{url : require('@/assets/images/yellow-map-marker-icon.png')}"
      />
    </GmapMap> -->
  </div>
</template>

<script>
const { getDate, getTime } = require('../../helper/commonHelpers.js')

export default {
  name: 'order-status',
  props: {
    statusUpdates: Array,
    vehicleLocation: {
      type: Object,
      default: () => {
        return {
          lat: 0,
          lng: 0
        }
      }
    }
  },
  methods: {
    getDate (t) {
      return getDate(t)
    },
    getTime (t) {
      return getTime(t)
    }
  }
}
</script>

<style lang="scss" scoped>

.label-text {
  @extend .f7 ;
  color: $--color-text-gray;
}

</style>
